export interface DiceGroup { label: string; sign: number; sides: number; faces: number[]; modifier: number; total: number }
export interface DiceResult { expression: string; groups: DiceGroup[]; total: number }
/** Bounded dice grammar, including labeled pools. Rules interpret individual faces. */
export function rollDice(expression: string, randomFace?: (sides: number) => number): DiceResult {
  const source = expression.replace(/\s+/g, "");
  if (!source || source.length > 300) throw new Error("Invalid dice expression");
  const pattern = /([+-]?)(?:(\d*)d(\d+)|(\d+))(?:\[([^\]]{1,40})\])?/gy;
  const groups: DiceGroup[] = [];
  let offset = 0, diceCount = 0;
  const face = randomFace ?? ((sides: number) => {
    const limit = Math.floor(0x100000000 / sides) * sides;
    const bytes = new Uint32Array(1);
    do { crypto.getRandomValues(bytes); } while (bytes[0]! >= limit);
    return bytes[0]! % sides + 1;
  });
  while (offset < source.length) {
    pattern.lastIndex = offset;
    const match = pattern.exec(source);
    if (!match || (offset > 0 && !match[1])) throw new Error("Unsupported dice syntax");
    offset = pattern.lastIndex;
    const sign = match[1] === "-" ? -1 : 1;
    const sides = Number(match[3] ?? 0), count = sides ? Number(match[2] || 1) : 0, modifier = Number(match[4] ?? 0);
    diceCount += count;
    if (count > 100 || diceCount > 200 || (sides && (sides < 2 || sides > 10000)) || modifier > 1000000 || groups.length >= 30) throw new Error("Dice limits exceeded");
    const faces = Array.from({ length: count }, () => { const value = face(sides); if (!Number.isInteger(value) || value < 1 || value > sides) throw new Error("Invalid die result"); return value; });
    groups.push({ label: match[5] || (sides ? `${count}d${sides}` : "Modifier"), sign, sides, faces, modifier, total: sign * (faces.reduce((sum, value) => sum + value, 0) + modifier) });
  }
  return { expression, groups, total: groups.reduce((sum, group) => sum + group.total, 0) };
}
